import { useTranslation } from "react-i18next";
import CoolnetPageLayout from "./components/CoolnetPageLayout";
import Layout from "@/components/feature/Layout";
import SEO from "@/components/feature/SEO";
import { coolnetLiquidCooling } from "@/mocks/coolnet";

export default function LiquidCoolingPage() {
  const { t } = useTranslation("home");

  return (
    <Layout>
      <SEO
        title="Refrigeracion Liquida para Centros de Datos | Coolnet Mexico"
        description="Refrigeracion liquida por immersion Coolnet para centros de datos. Tecnologia avanzada de enfriamiento para sistemas de alto rendimiento. Distribuidor autorizado en Mexico."
        keywords="refrigeracion liquida, immersion Coolnet, enfriamiento centros de datos, liquid cooling, data center cooling, Coolnet Mexico"
        canonical="https://ventracore.com.mx/coolnet/refrigeracion-liquida"
        schemas={[
          {
            "@context": "https://schema.org",
            "@type": "Product",
            "@id": "https://ventracore.com.mx/coolnet/refrigeracion-liquida#product",
            "name": "Refrigeracion Liquida Coolnet",
            "brand": {
              "@type": "Brand",
              "name": "Coolnet",
            },
            "description": "Refrigeracion liquida por immersion para centros de datos.",
            "offers": {
              "@type": "AggregateOffer",
              "availability": "https://schema.org/InStock",
              "priceCurrency": "MXN",
            },
          },
          {
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [
              {
                "@type": "ListItem",
                "position": 1,
                "name": "Inicio",
                "item": "https://ventracore.com.mx/",
              },
              {
                "@type": "ListItem",
                "position": 2,
                "name": "Coolnet",
                "item": "https://ventracore.com.mx/coolnet",
              },
              {
                "@type": "ListItem",
                "position": 3,
                "name": "Refrigeracion Liquida",
                "item": "https://ventracore.com.mx/coolnet/refrigeracion-liquida",
              },
            ],
          },
        ]}
      />
      <CoolnetPageLayout
        title={t("coolnetPage.liquid.title")}
        subtitle={t("coolnetPage.liquid.subtitle")}
      >
        <div className="max-w-5xl mx-auto">
          <p className="text-sm md:text-base text-text-muted leading-relaxed text-justify mb-10">
            {coolnetLiquidCooling.intro}
          </p>

          <h3 className="text-xl md:text-2xl font-bold text-magenta mb-8 uppercase tracking-wide">
            {t("coolnetPage.liquid.productsTitle")}
          </h3>

          <div className="space-y-10">
            {coolnetLiquidCooling.products.map((product, index) => (
              <div
                key={index}
                className={`flex flex-col ${
                  index % 2 === 0 ? "lg:flex-row" : "lg:flex-row-reverse"
                } items-center gap-6 lg:gap-10`}
              >
                <div className="w-full lg:w-1/2 h-56 md:h-72 overflow-hidden rounded-lg">
                  <img
                    src={product.image}
                    alt={product.title}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="w-full lg:w-1/2">
                  <h4 className="text-lg md:text-xl font-bold text-brandgreen mb-3">
                    {product.title}
                  </h4>
                  <p className="text-sm md:text-base text-text-muted leading-relaxed text-justify">
                    {product.description}
                  </p>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-12 text-center">
            <p className="text-sm text-text-muted">
              {coolnetLiquidCooling.contact}
            </p>
          </div>
        </div>
      </CoolnetPageLayout>
    </Layout>
  );
}